<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: 'min(96vw, 72rem)', height: 'min(90vh, 52rem)' }"
  contentStyleClass="!p-0 !overflow-hidden !flex !flex-col !h-full"
  styleClass="charge-followup-dialog"
>
  <ng-template pTemplate="header">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-900">{{ title() }}</h2>
      @if (subtitle()) {
        <p class="text-sm text-slate-500 truncate">{{ subtitle() }}</p>
      }
    </div>
  </ng-template>

  <div class="charge-followup-shell relative flex flex-1 min-h-0 gap-0 border-t border-slate-200 bg-white">
    @if (chargeLoading()) {
      <div
        class="absolute inset-0 z-40 flex items-center justify-center bg-slate-400/25 backdrop-blur-[2px]"
        role="status"
        aria-live="polite"
        aria-busy="true">
        <div class="flex flex-col items-center gap-3 rounded-2xl border border-slate-300/80 bg-white/95 px-8 py-6 shadow-lg">
          <i class="pi pi-spin pi-spinner text-3xl text-sky-600"></i>
          <p class="text-sm font-semibold text-slate-800">Cargando recibo…</p>
        </div>
      </div>
    }
    <nav
      class="followup-nav w-56 shrink-0 border-r border-slate-200 bg-slate-100/80 p-3 flex flex-col gap-1.5"
      role="tablist"
      aria-label="Secciones de seguimiento"
    >
      <p class="followup-nav__title px-2 pb-1 text-[0.6875rem] font-semibold uppercase tracking-wider text-slate-400">
        Secciones
      </p>
      <button
        type="button"
        role="tab"
        class="followup-tab"
        [class.followup-tab--active]="activeTab() === 'email'"
        [attr.aria-selected]="activeTab() === 'email'"
        (click)="selectTab('email')"
      >
        <span class="followup-tab__icon" aria-hidden="true">
          <i class="pi pi-envelope"></i>
        </span>
        <span class="followup-tab__text">
          <span class="followup-tab__label">Email</span>
          <span class="followup-tab__hint">Enviar correo</span>
        </span>
      </button>
      <button
        type="button"
        role="tab"
        class="followup-tab"
        [class.followup-tab--active]="activeTab() === 'bitacora'"
        [attr.aria-selected]="activeTab() === 'bitacora'"
        (click)="selectTab('bitacora')"
      >
        <span class="followup-tab__icon" aria-hidden="true">
          <i class="pi pi-history"></i>
        </span>
        <span class="followup-tab__text">
          <span class="followup-tab__label">Bitácora</span>
          <span class="followup-tab__hint">Correos y notas</span>
        </span>
      </button>
      <button
        type="button"
        role="tab"
        class="followup-tab"
        [class.followup-tab--active]="activeTab() === 'seguimiento'"
        [attr.aria-selected]="activeTab() === 'seguimiento'"
        (click)="selectTab('seguimiento')"
      >
        <span
          class="followup-tab__icon"
          [class.!bg-rose-100]="isBrokenCommitment()"
          [class.!text-rose-600]="isBrokenCommitment()"
          aria-hidden="true"
        >
          <i [class]="isBrokenCommitment() ? 'pi pi-exclamation-triangle' : 'pi pi-calendar'"></i>
        </span>
        <span class="followup-tab__text">
          <span
            class="followup-tab__label"
            [class.!text-rose-700]="isBrokenCommitment() && activeTab() !== 'seguimiento'"
          >Seguimiento</span>
          <span
            class="followup-tab__hint"
            [class.!text-rose-500]="isBrokenCommitment() && activeTab() !== 'seguimiento'"
          >{{ isBrokenCommitment() ? 'Compromiso vencido' : 'Compromiso de pago' }}</span>
        </span>
      </button>
    </nav>

    <div class="flex flex-1 min-w-0 min-h-0 flex-col">
      <div class="charge-followup-content flex min-h-0 flex-1 flex-col overflow-hidden p-4">
        <div
          class="flex min-h-0 flex-1 flex-col overflow-hidden"
          [class.hidden]="activeTab() !== 'email'"
        >
          <app-send-communication-form
            #sendForm
            class="min-h-0 flex-1"
            [chargeId]="chargeId()"
            [saleId]="saleId()"
            [defaultEmail]="customerEmail()"
            [showFooterActions]="false"
            (sent)="onCommunicationSent()"
            (formStateChange)="onSendFormStateChange()"
          />
        </div>
        <div
          class="flex min-h-0 flex-1 flex-col overflow-hidden"
          [class.hidden]="activeTab() !== 'bitacora'"
        >
          <app-sale-communication-panel
            #bitacoraPanel
            [chargeId]="chargeId()"
            [saleId]="saleId()"
            [embedded]="true"
            [showHeaderActions]="false"
            [allowInternalNotes]="true"
          />
        </div>
        <div
          class="flex min-h-0 flex-1 flex-col overflow-auto"
          [class.hidden]="activeTab() !== 'seguimiento'"
        >
          <form [formGroup]="seguimientoForm" class="flex max-w-md flex-col gap-3">
            <p class="text-sm text-slate-600">
              Registra la fecha en que el cliente se comprometió a pagar este recibo.
            </p>
            @if (isBrokenCommitment()) {
              <div
                class="flex items-start gap-2 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-800"
                role="alert"
              >
                <i class="pi pi-exclamation-triangle mt-0.5 shrink-0 text-rose-600" aria-hidden="true"></i>
                <span>El recibo está vencido y la fecha compromiso de pago ya pasó.</span>
              </div>
            }
            <div class="flex flex-col gap-1">
              <p-floatlabel class="w-full" variant="on">
                <p-datepicker
                  formControlName="commitmentDate"
                  inputId="commitmentDate"
                  [showTime]="false"
                  dateFormat="dd/mm/yy"
                  placeholder="dd/mm/aaaa"
                  [showClear]="true"
                  fluid
                />
                <label for="commitmentDate">Fecha compromiso de pago</label>
              </p-floatlabel>
              <small class="text-slate-500">Opcional. Puedes limpiarla si ya no aplica.</small>
            </div>
          </form>
        </div>
      </div>

      <footer class="charge-followup-footer shrink-0 border-t border-slate-200 bg-slate-50 px-4 py-3 flex justify-end gap-2">
        @if (activeTab() === 'email') {
          <p-button
            type="button"
            label="Enviar"
            icon="pi pi-send"
            [loading]="sendFormRef()?.sending ?? false"
            [disabled]="chargeLoading() || (sendFormRef()?.isSubmitDisabled() ?? true)"
            appDisableUnless="COMMUNICATION_WRITE"
            (onClick)="sendFormRef()?.sendCommunication()"
          />
        } @else if (activeTab() === 'bitacora') {
          <p-button
            type="button"
            label="Actualizar"
            icon="pi pi-refresh"
            [outlined]="true"
            [loading]="communicationPanelRef()?.loading() ?? false"
            [disabled]="communicationPanelRef()?.loading() ?? false"
            (onClick)="communicationPanelRef()?.load()"
          />
        } @else {
          <p-button
            type="button"
            label="Guardar"
            icon="pi pi-check"
            [loading]="savingCommitment()"
            [disabled]="chargeLoading() || savingCommitment()"
            appDisableUnless="CHARGE_WRITE"
            (onClick)="saveCommitmentDate()"
          />
        }
      </footer>
    </div>
  </div>
</p-dialog>
